import { MsgConfig } from "src/app/app.messages";
import { SystemData, AccCategoryE, EditRxE, RxModel, RxAuditLog } from "src/app/models";
import { CommonService, RxService, AlertService } from "src/app/services";
import { FormArray, FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from "@angular/core";
import * as moment from "moment";
import { NgbDateStruct, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DomSanitizer } from "@angular/platform-browser";
import { PrivMaskGuard } from "src/app/guards";
import { LocalTimePipe } from "src/app/pipes";
import { NewAuditUtils } from "src/app/utils/new-audit.util";
import { PrimeEscService } from "src/app/services/prime-esc.service";
import { CustomDateParserFormatter } from "../../cust-form-elemns";
import { DateCheckUtil } from "src/app/utils/date-checks.util";
import { PrintService } from "src/app/services/print.service";
import { forkJoin, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { FormatsUtil } from "src/app/utils/formats.util";
import { environment } from "src/environments/environment";
import { SignatureType,PickupSource } from "src/app/models/rx.enum";


@Component({
    selector: "app-pickuprx",
    templateUrl: "./pickuprx.component.html",
    standalone: false
})
export class PickuprxComponent implements OnInit {
    @Input() SystemData: SystemData;
    @Input() rxDetails: RxModel;
    @Output() IsPopUpClosed = new EventEmitter<any>();
    @Input() rxFG: FormGroup;

    @ViewChild("PICKUPDELETECNFRM", { static: true })
    PICKUPDELETECNFRM: any;

    unsubscribe$ : Subject<void> = new Subject();
    localTimePipe = new LocalTimePipe();

    pickupFG: any;
    rxId: number;
    prscRfId: any;
    pickUpDetails: any;
    today: any;
    time: any;
    formGroupInvalid: boolean;
    todayTm: any;
    minDate: any;
    presRefIdF: any;
    time1: moment.Moment;
    todayTm1: string;
    imgURL: string;
    imageToShow: any;
    route: string;
    hasSignature: boolean;
    hasReceiptData: boolean;
    accessPrivCate: any;
    editRxPrivs: any;
    pickupMinDate: any;

    signatureData: any;
    sigType: any;
    signId: any;
    showPatientSign: boolean;
    rxPatientModel: any;
    refillId: any;
    disableDateField: boolean;
    pickTimeForDisplay: string = "AM";
    isPickTimeValid: any = false;
    RPH: any;
    rxNumber: string;
    readonly DELIMITER = '/';
    dateParser=new CustomDateParserFormatter();
    rxPickupFromOptions: any;
    isCancel:boolean = false;
    newPickUpFG: FormGroup;
    pickupLists: any;
    originalPickupLists : any;
    notesLogFG: FormGroup;
    pdfContent: any;
    @ViewChild("posReceipt", { static: true })
    posReceipt: any;
    dataToPrint: any;
    openNotesPopup: boolean;
    selectedPickupInfo: any;
    selectedIOUPickup: any;
    isPickupEnabled = environment.isPickUpEnabled;
    signatureType = SignatureType 
    pickupSrcEnums = PickupSource;
    mandateFieldsYes: any;
    displayMandateSetting: boolean = environment.isMandateFieldsPickup
    get ExpDtTm(): FormControl {
        return this.pickupFG.get("ExpDtTm") as FormControl;
    }
    get PRESCREFILL(): FormGroup {
        return this.rxFG.controls["PrescReFill"] as FormGroup;
    }
    constructor(
        private _fb: FormBuilder,
        public _commonSvc: CommonService,
        private _rxService: RxService,
        private _alertSvc: AlertService,
        private _privMaskGuard: PrivMaskGuard,
        private _sanitizer: DomSanitizer,
        private _modalService: NgbModal,
        private _nwAudtUtl: NewAuditUtils,
        private _primeEscSer: PrimeEscService,
        private _dateChecks: DateCheckUtil,
        public _printServ: PrintService,
        public _formatsUtil: FormatsUtil
    ) {
        this.accessPrivCate = AccCategoryE;
        this.editRxPrivs = EditRxE;
        this.createPickupG();
        this.newPickUpFG = this._fb.group({
            pickupDetails: this._fb.array([]) // Stores all objects dynamically
        });
        this._commonSvc.systemData$.pipe(takeUntil(this.unsubscribe$)).subscribe(resp => {
            if (resp) {
               this.rxPickupFromOptions = resp.pickUpFrom ? resp.pickUpFrom : [];
            }
        });
    }

    ngOnInit() {
        this.pickupFG.controls["IsPickedUp"].patchValue(this.rxFG?.value?.pickupRx?.IsPickedUp ? this.rxFG?.value?.pickupRx?.IsPickedUp : false)
        this.getCurrentDateFormat();
        if (!this.isPickupEnabled) {
            this.getPickupDetails();
        } else {
            this.getnewPickupDetails();
        }
        if (this.rxDetails) {
            this.pickupMinDate = moment(this.rxDetails.PrescReFill.FillDtTm).format("MM/DD/YYYY");
        }
    }
    
    get pickupDetails(): FormArray {
        return this.newPickUpFG.get('pickupDetails') as FormArray;
    }
    getCurrentDateFormat() {
        const today = new Date();
        this.today = moment().format("MM/DD/YYYY");
        this.minDate = {
            year: today.getFullYear(),
            month: today.getMonth() + 1,
            day: today.getDate()
        };
        this.time1 = moment();
        this.todayTm1 = this.time1.hour() + ":" + this.time1.minutes();
        this.time = moment().format("HH:mm A");
        this.todayTm = moment().format("MM/DD/YYYY HH:mm A");
    }

    getPartialFillNo() {
        return this._commonSvc.checkIsPartialFill(this.rxDetails?.PrescReFill, this.rxDetails?.Prescription) ? this.rxDetails?.PrescReFill?.PartialFillNo : "";
    }


    parse(value: string): NgbDateStruct | null {
        if (value) {
            let date = value.split(this.DELIMITER);
            return {
                day: parseInt(date[1], 10),
                month: parseInt(date[0], 10),
                year: parseInt(date[2], 10)
            };
        }
        return null;
    }
    createPickupG() {
        this.pickupFG = this._fb.group({
            Id: [],
            TenantId: [],
            RxRefillId: [],
            DropPickQulifierName: [],
            IdProof: [],
            RelRemarks: [],
            ExpDtTm: [],
            ExpDttm1: [],
            IsPickedUp: false,
            PickUpPos: false,
            POSTransId: [],
            POSUserId: [],
            ActDtTm: [],
            PkFirstName: [],
            PkLastName: [],
            RelationCatId: [],
            PkIdNum: [],
            PkIdProofId: [],
            PkIdIssuer: [],
            Remarks: [],
            HandOverById: [],
            Acttime: [],
            prescNum: [],
            reFillNum: [],
            PartialfillNum: [],
            DropPickQ: [],
            ExpDate: null,
            PickUpFromId: null
        });
    }


    /* not using createImageFromBlob(image: Blob) {
        const urlCreator = window.URL;
        this.imageToShow = this._sanitizer.bypassSecurityTrustResourceUrl(
            urlCreator.createObjectURL(image)
        );
    }*/
    getPickTimeForDisplay(pickupItem?) {
        if (pickupItem?.value) {
            pickupItem.controls["pickTimeForDisplay"].patchValue(pickupItem.value["pickTimeForDisplay"] === "AM" ? "PM" : "AM")
        } else {
            this.pickTimeForDisplay = (this.pickTimeForDisplay === "AM") ?"PM" :"AM";
        }
    }

    
    async getPickupDetails(frmSave?) {
        const pickupSvc = [];
        let Sign;
        // this.pickUpDetails = await this._rxService.getPickupDetails(this.rxDetails["PrescReFill"]["Id"]).toPromise();
        pickupSvc.push(this._rxService.getPickupDetails(this.rxDetails["PrescReFill"]["Id"]));
        pickupSvc.push(this._rxService.getSignatureDetails(this.rxDetails["PrescReFill"]["Id"]));
        const respPickUp = await forkJoin(pickupSvc).toPromise() as any[];
        if(respPickUp?.length) {
            this.pickUpDetails = respPickUp[0];
            Sign = respPickUp[1];
        }
        if (this.pickUpDetails) {
            if(this.pickUpDetails.hasReceiptDetails == 1) {
                this.hasReceiptData = true;
            }
            // const Sign = await this._rxService.getSignatureDetails(this.rxDetails["PrescReFill"]["Id"]).toPromise();
            if (Sign) {
                this.hasSignature = true;
                this.imageToShow = "data:image/png;base64," + Sign;
            } else {
                this.hasSignature = false;
            }
            this.pickupFG.patchValue(this.pickUpDetails);
            this.pickupFG.controls.ExpDtTm.patchValue(
                this.pickUpDetails["ExpDtTm"] ? moment.utc(this.pickUpDetails["ExpDtTm"]).local().format("MM/DD/YYYY hh:mm:ss a") : null);
            this.pickupFG.controls["ExpDttm1"].patchValue(this.pickupFG.value["ExpDtTm"]);
            if( this.pickUpDetails["ExpDtTm"]) {
                this.getPickupDate(false);
            }
            this.pickupFG.controls.ActDtTm.patchValue(
                    this.pickUpDetails["ActDtTm"] ? moment.utc(this.pickUpDetails["ActDtTm"]).local().format("MM/DD/YYYY") : null);
            this.pickupFG.markAsPristine();
            if(frmSave){
                this.IsPopUpClosed.emit("Patient1");
            }
        }
    }
    withChangeInDateSetTime() {
        const date = moment(this.pickupFG.value["ExpDtTm"]).format("MM/DD/YYYY");
        // const time = moment().format("hh:mm:ss");
        const dateTime = moment(date + "", "MM/DD/YYYY");
        const dateTimeForDisplay = moment(date + "" +  moment().format("HH:mm:ss"), "MM/DD/YYYY HH:mm:ss a");
        this.pickTimeForDisplay = moment(dateTimeForDisplay).format("a");
        this.pickupFG.controls["ExpDtTm"].patchValue(moment(dateTime).format("MM/DD/YYYY"));
        let previousTime = this.pickupFG.value["ExpDate"] + " " + this.pickTimeForDisplay ;
        if(this.pickUpDetails)
            this.pickUpDetails.ExpDate = previousTime;
    }
    saveAuditChange() {
        const pickupRxAuditModel = new RxAuditLog().pickupRxAuditModel;
        this._nwAudtUtl.saveAuditChange(
            this.pickUpDetails,
            this.pickupFG.getRawValue(),
            "PickUpInfo",
            "Rx",
            this.rxDetails.PrescReFill.Id,
            pickupRxAuditModel
        );
    }
    checkPikcUpTimeValidation(type : boolean = false, fromNew?, pickupItem?) {
        let itemFG = fromNew ? pickupItem : this.pickupFG
        fromNew ? pickupItem.value["isPickTimeValid"] = false : this.isPickTimeValid = false;
        if (itemFG.value["ExpDate"]) {
            const expDate = itemFG.value["ExpDate"];
            const date: any = expDate.split(":");
            if (date && date.length) {
                date[0] = parseInt(date[0], 0);
                date[1] = parseInt(date[1], 0);
                date[2] = parseInt(date[2], 0);
                if (date[0] > 12 || date[1] > 59 || date[2] > 59) {
                    fromNew ? pickupItem.value["isPickTimeValid"] = true : this.isPickTimeValid = true;
                }
            }
        } else {
            itemFG.controls["ExpDate"].patchValue(null);
        }
        if(!type) {
            if(document.getElementById("DropPickQ") && document.getElementById("DropPickQ").getElementsByTagName('input'))
            {
                const dropTag: any = document.getElementById("DropPickQ").getElementsByTagName('input')[0];
                if (dropTag)
                    dropTag.focus();
            }
        }
        return fromNew ? pickupItem.value["isPickTimeValid"] : this.isPickTimeValid;
    }
    async savePickUp(type?: any) {
        if (!this.isPickupEnabled) {
            const pickUpExpDtTmFG = this._fb.group({ExpDtTm: this.pickupFG.controls["ExpDtTm"].value});
        var dateChecks = [{
            control : "ExpDtTm",
            minDate:  this.dateParser.parse(this.pickupMinDate),
            maxDate: "",
            isRequired: this.pickupFG.value.IsPickedUp,
            Id:"pickUpRx"
        }]
        if(this._dateChecks.checkDateValidationAtTimeofSave(pickUpExpDtTmFG, dateChecks)) {
            return ;
        } else {
            if (this.checkPikcUpTimeValidation(true)){
                return;
            }
            this.pickupFG.patchValue({
                RxRefillId: this.rxDetails["PrescReFill"]["Id"],
                prescNum: this.rxDetails.Prescription.PrescNum,
                reFillNum: this.rxDetails.PrescReFill.ReFillNum,
                PartialfillNum: this.rxDetails.PrescReFill.PartialFillNo,
                ExpDate: this.pickupFG.value["ExpDate"] ? this.pickupFG.value["ExpDate"] + " " + this.pickTimeForDisplay : null
            });
            if (!this.pickupFG.value["IsPickedUp"] || (this.pickupFG.value["IsPickedUp"] && this.pickupFG.value["ExpDtTm"])) {
                this.formGroupInvalid = false;
                if (this.pickupFG.value["ExpDtTm"]) {
                    const actDt = moment.utc(this.pickupFG.value.ExpDtTm)
                    .add(this.rxFG.value.PrescReFill.SupplyDays, "days")
                    .local().format("YYYY-MM-DD");
                    this.pickupFG.patchValue({
                        ActDtTm: actDt,
                    });
                }
                if (this.pickUpDetails) {
                    const resp = await this._rxService.editPickupDetails(this.pickupFG.value).toPromise();
                        if (resp) {
                            if (this.rxFG && this.rxFG.controls["pickupRx"]) {
                                this.rxFG.controls["pickupRx"].patchValue({IsPickedUp : this.pickupFG.value["IsPickedUp"]});
                            }
                            this.saveAuditChange();
                            if (!type) {
                            this._alertSvc.success(MsgConfig.SAVE_SUCCESS);
                            this.getPickupDetails(true);
                            }
                        } else {
                            if (!type) {
                            this._alertSvc.error(MsgConfig.SAVE_FAIL);
                            }
                        }
                } else {
                    const resp = await this._rxService.addPickupDetails(this.pickupFG.value).toPromise();
                    if (resp) {
                        if (this.rxFG && this.rxFG.controls["pickupRx"]) {
                            this.rxFG.controls["pickupRx"].patchValue({IsPickedUp : this.pickupFG.value["IsPickedUp"]});
                        }
                        this.saveAuditChange();
                        if (!type) {
                        this._alertSvc.success(MsgConfig.SAVE_SUCCESS);
                        this.getPickupDetails(true);
                        }
                    }
                }
            } else {
                this.formGroupInvalid = true;
                if (!type) {
                    this._alertSvc.error(MsgConfig.ENTER_REQ_FIELD);
                }
            }
            }
        }
        if (this.isPickupEnabled) {
            this.pickupDetails.controls.map((item:any) =>{
                if (this.checkPikcUpTimeValidation(true, true, item)){
                    return;
                }
            });
            this.pickupLists.map((item: any) => {
                this.pickupDetails.controls.map((itemFG: any) => {
                    if(itemFG.value["Id"] === item.Id) {
                        Object.keys(itemFG.value).forEach((key) => {
                            item[key] = itemFG.value[key];
                        });
                    }
                })
            });
            let missingFieldsError = false;
            const requiredKeys = ["PkFirstName", "PkLastName", "RelationCatId", "PkIdNum", "PkIdProofId"];
            this.pickupDetails.controls.map(async (itemFG: any) => {
                const validPickup = (!this.mandateFieldsYes || requiredKeys.every(key => !!itemFG.value[key]))
                if(!itemFG.value["IsPickedUp"] || (itemFG.value["IsPickedUp"] && itemFG.value["ExpDtTm"] && validPickup)) {
                    if (itemFG.value["ExpDtTm"]) {
                        const actDt = moment.utc(itemFG.value.ExpDtTm)
                        .add(this.rxFG.value.PrescReFill.SupplyDays, "days")
                        .local().format("YYYY-MM-DD");
                        itemFG.patchValue({
                            ActDtTm: actDt,
                        });
                    }
                } else {
                    missingFieldsError = true;
                    this.formGroupInvalid = true;
                }
            });
            if (!missingFieldsError) {
                this.formGroupInvalid = false;
                const datatoSend = {PickupRxHistory : this.pickupLists};
                const resp: any = await this._rxService.updatePickupDetails(datatoSend).toPromise();
                if (resp?.Response) {
                    let count =0;
                    if (this.rxFG && this.rxFG.controls["pickupRx"]) {
                        this.rxFG.controls["pickupRx"].patchValue({
                            IsPickedUp : resp.IsPickedup,
                            IsPartialPickup: resp.IsPartialPickup
                        });
                    }
                    this.pickupDetails.controls.map((itemFG: any) => {
                        this.savenewAuditChange(itemFG);
                        count++;
                        if (!type && count === this.pickupLists?.length) {
                            this._alertSvc.success(MsgConfig.SAVE_SUCCESS);
                            this.getnewPickupDetails(true);
                        }
                    });
                } else {
                    if (!type) {
                        this._alertSvc.error(MsgConfig.SAVE_FAIL);
                    }
                }
            } else {
                if (!type) {
                    this._alertSvc.error(MsgConfig.ENTER_REQ_FIELD);
                }
            }
        }
    }
    openPickUpPrint() {

        if(this.rxFG && this.rxFG.controls["Prescription"] && this.rxFG.controls["PrescReFill"]) {
        this.rxNumber = this.rxFG.controls["Prescription"].value.PrescNum + "-" + this.rxFG.controls["PrescReFill"].value.ReFillNum + (this._commonSvc.checkIsPartialFill(this.rxFG.controls["PrescReFill"].value, this.rxFG.controls["Prescription"].value) ? "-" + this.rxFG.controls["PrescReFill"].value.PartialFillNo : "") + "(" + this.rxFG.controls["insuranceInfo"].value.insuCarrier.InsurerCode + ")";
        this._rxService.getPickupPrintDetails(this.rxFG.controls["PrescReFill"].value.Id).pipe(takeUntil(this.unsubscribe$)).subscribe((transId: any) => {
             this._primeEscSer.getPatAckSign(transId?.Id, false).pipe(takeUntil(this.unsubscribe$))
        .subscribe(resp => {
            this.rxPatientModel = this.rxFG.get("Patient").value;
            this.showPatientSign = true;
            this.signId = transId.Id;
            this.refillId = this.rxFG.controls["PrescReFill"].value.Id;
            this.RPH = transId.RPH;
            this.signatureData = resp;
              });
        });
     }
    }
    getPickupDate(isFromSelection) {
        let time;
        time =  moment(this.pickupFG.value["ExpDtTm"]).format("hh:mm:ss");
        if (isFromSelection) {
            this.pickupFG.controls["ExpDtTm"].patchValue(moment(this.pickupFG.value["ExpDtTm"]).format("MM/DD/YYYY"));
            time = this.pickupFG.value["IsPickedUp"] ?  this.pickupFG.value["ExpDate"] : moment().format("hh:mm:ss");
        }
        const date = moment(this.pickupFG.value["ExpDtTm"]).format("MM/DD/YYYY");
        this.pickTimeForDisplay = moment(this.pickupFG.value["ExpDtTm"]).format("a");
        // const dateTime = moment(date + "" + time, "MM/DD/YYYY hh:mm:ss");
        const a = this.pickupFG.controls["ExpDtTm"].patchValue(moment(date).format("MM/DD/YYYY"));
        this.pickupFG.controls["ExpDate"].patchValue(time);
        let previousTime = this.pickupFG.value["ExpDate"] + " " + this.pickTimeForDisplay ;
        if(this.pickUpDetails)
              this.pickUpDetails.ExpDate = previousTime;
    }
    setVal() {
        // const fillDtTm = this.PRESCREFILL.value.FillDtTm ? moment(this.PRESCREFILL.value.FillDtTm).format(MsgConfig.DATE_FORMAT) : null;
        // const expDtTm =
        // (this.pickupFG.value["ExpDtTm"]) ? moment(this.pickupFG.value["ExpDtTm"]).format(MsgConfig.DATE_FORMAT) : moment().format(MsgConfig.DATE_FORMAT);
        // const filDateDiffPickup = (fillDtTm && expDtTm) ?   moment(expDtTm).startOf("day").diff(moment(fillDtTm).startOf("day"), "days") : null;
        this.formGroupInvalid = false;
        if (this.checkHasPrivsToAccess(
            this.accessPrivCate.EditRx,
            this.editRxPrivs.CheckUncheckPickupRecord
        ) ) {
            if (this.pickupFG.value["IsPickedUp"]) {
                this.pickupFG.controls["PkFirstName"].patchValue(
                    this.rxDetails["Patient"]["firstname"]
                );
                this.pickupFG.controls["PkLastName"].patchValue(
                    this.rxDetails["Patient"]["lastname"]
                );
                this.pickupFG.controls["ExpDtTm"].patchValue(new Date());
                this.pickupFG.controls["ExpDttm1"].patchValue(new Date());
                this.getPickupDate(false);
                this.pickupFG.controls["ActDtTm"].patchValue(new Date());
                // Audit Alert - "Class 2 Drugs should be picked up within 30 days from Fill date"
                // if(this.rxFG.value  && this.rxFG.value["Drug"] && this.rxFG.value["Drug"]["drugclass"]  && +this.rxFG.value["Drug"]["drugclass"] === 2 && filDateDiffPickup && filDateDiffPickup > 30){
                //     const modelRef = this._modalService.open(CommonWarnorconfirmPopupComponent, {
                //         backdrop: false,
                //         keyboard: false, windowClass: "large--content"
                //     });
                //     modelRef.componentInstance.IsHeaderText ="Warning!!";
                //     modelRef.componentInstance.warnMsg = "According to compliance, pickup for Class 2 drug should be completed within 30 days, otherwise an audit may be conducted for continued Rx.";
                //     modelRef.componentInstance.okButton = true;
                //     modelRef.componentInstance.IsPopUpClosed.subscribe((resp: any) => {
                //         modelRef.close();
                //     });
                // }

                // this.pickupFG.controls["Acttime"].patchValue( this.time );
            } else {
                this.pickupFG.controls["IsPickedUp"].setValue(false);
                //open model
                this._modalService.open(this.PICKUPDELETECNFRM, { backdrop: "static", keyboard: false, centered: true,
                 windowClass: "large--content" });
                // this.pickupFG.reset();
            }
        } else {
            this.pickupFG.controls["IsPickedUp"].patchValue(!this.pickupFG.value["IsPickedUp"]);
            this._alertSvc.error("User does not have privileges to perform this action.", false, "long");
        }
        this.formGroupInvalid = true;
    }

    resetPickupRx(val: boolean) {
        let itemFG = this.selectedIOUPickup ? this.selectedIOUPickup : this.pickupFG
        if (val) {
        this.selectedIOUPickup ?  this.selectedIOUPickup.controls["disableDateField"].patchValue(false) : this.disableDateField = false;
        let fgVal = itemFG.value;
        itemFG.reset();
        itemFG.controls["ExpDtTm"].setValue(null);
        itemFG.controls["ExpDtTm"].setErrors(null);
        itemFG.controls["ExpDtTm"].setValidators(null);
        itemFG.controls["ExpDtTm"].markAsTouched();
        itemFG.controls["ExpDtTm"].updateValueAndValidity();
        itemFG.patchValue({
            Id: fgVal.Id,
            TenantId: fgVal.TenantId,
            IsPickedUp: false,
            IsPartialPickup : true,
            IsRphVerified : fgVal.IsRphVerified,
            DrugName: fgVal.DrugName,
            DpvId: fgVal.DpvId,
            IOUQty: fgVal.IOUQty,
            NDC: fgVal.NDC,
            Qty: fgVal.Qty,
            pickTimeForDisplay: "AM",
            RxRefillId: fgVal.RxRefillId,
            IsPickupHistory: fgVal.IsPickupHistory,
            PickUpFromId: fgVal.PickUpFromId,
            POSTransId: fgVal.POSTransId
        });
        itemFG.markAsDirty();
        this.formGroupInvalid = false;
        } else {
            itemFG.controls["IsPickedUp"].patchValue(true);
            this.selectedIOUPickup ?  this.selectedIOUPickup.controls["disableDateField"].patchValue(true) : this.disableDateField = true;
        }
    }

    checkHasPrivsToAccess(category: string, privType: string) {
        return this._privMaskGuard.canActivate(category, privType);
    }

    previousPage() {
        this.isCancel = true;
        this.pickupFG.reset();
        this.IsPopUpClosed.emit("Patient1");
    }

    focusOutFromRadio(event) {
        if (!this.pickupFG.value["IsPickedUp"]) {
           this.focusOnSave(event);
        }
    }

    focusOnSave(event) {
        if (document.getElementById("SaveButton")) {
            event.preventDefault();
            document.getElementById("SaveButton").focus();
        }
    }

   

    PrintPOSReceipt(){
        this._primeEscSer.getPOSreceipt(this.pickUpDetails.Id).pipe(takeUntil(this.unsubscribe$))
            .subscribe(resp => {
                if (resp && resp.size > 0 && resp.type === "application/pdf") {
                    const newBlob = new Blob([resp], { type: "application/pdf" });
                    const reader = new FileReader();
                    reader.readAsDataURL(newBlob);
                    reader.onloadend = function () {
                        const base64data = reader.result;
                        this._printServ.printPdf(base64data);
                    }.bind(this);
                } else {
                    this._alertSvc.error("Print Unsuccessfull.");
                }
            });
    }
    async getnewPickupDetails(frmSave?) {
        const newResp:any = await this._rxService.getRxPickupDetails(this.rxDetails["PrescReFill"]["Id"]).toPromise();
        this.pickupLists = newResp?.PickupRxHistory;
        this.originalPickupLists = JSON.parse(JSON.stringify(newResp?.PickupRxHistory|| []))
        if(this.pickupLists?.length) {
            this.displayPickUp();
            setTimeout(() => {
                this.pickupDetails.controls.map((item:any) =>{
                    if(item?.value?.SignHistory?.length && item?.value?.SignHistory.find((signItem: any) => signItem?.BinarySign)) {
                        item.controls["hasSignature"].patchValue(true);
                    } else {
                        item.controls["hasSignature"].patchValue(false);
                    }
                    const index = this.pickupLists.findIndex((itemIndex: any) => itemIndex.Id === item.value["Id"]);
                    if (this.pickupLists[index].ExpDtTm) {
                        this.getNewPickupDate(false, item);
                    }
                    item.controls.ActDtTm.patchValue(
                        this.pickupLists[index]["ActDtTm"] ? moment.utc(this.pickupLists[index]["ActDtTm"]).local().format("MM/DD/YYYY") : null);
                    item.markAsPristine();
                })
            }, 10);
            if(frmSave){
                this.IsPopUpClosed.emit("Patient1");
            }
        }
    }

    signaturesToShow(pickupSign, pickupItem) {
        const val = "data:image/png;base64," +pickupSign?.BinarySign
        return val;
    }
    displayPickUp() {
        if (this.displayMandateSetting) {
            let settingVal =  this._commonSvc.getSetttingValue("ControlFileSettings", "Mandate_ID_to_Dispense");
            if (typeof settingVal === "string") {
                settingVal = settingVal.trim();
            }
            let drugClass = this.rxFG.value["Drug"]["drugclass"];

            let nonControlDrug = (drugClass === 0 || drugClass === 1 || drugClass === 6);
            let controlDrug = (drugClass >= 2 && drugClass <= 5);

            let settingArray = [];
            if (settingVal && settingVal !== "6" && settingVal.includes(',')) {
                // Only split into array if it's not the special code "6" and contains comma, otherwise treat it as a single value
                settingArray = settingVal.split(",").map(s => s.trim());
            } else if (settingVal && settingVal !== "0" && settingVal !== "6" && settingVal !== "7" && !settingVal.includes(',')) {
                // Single drug class value (not a special code "0" or "6" or "7")
                settingArray = [settingVal];
            }
            this.mandateFieldsYes =
                !settingVal ||
                settingVal === "0" ||
                (settingVal === "6" && controlDrug) ||
                (settingVal === "7" && nonControlDrug) ||
                settingArray.includes(drugClass.toString());
        }
        const pickUpArray = this.newPickUpFG.get('pickupDetails') as FormArray;
        this.pickupLists.forEach(item => {
            pickUpArray.push(this._fb.group({
            Id: new FormControl(item.Id),
            TenantId: new FormControl(item.TenantId),
            RxRefillId: new FormControl(item.RxRefillId),
            DropPickQulifierName: new FormControl(item.DropPickQulifierName),
            IdProof: new FormControl(item.IdProof),
            RelRemarks: new FormControl(item.RelRemarks),
            ExpDtTm: new FormControl(item.ExpDtTm ? moment.utc(item.ExpDtTm).local().format("MM/DD/YYYY hh:mm:ss a") : null),
            ExpDttm1: new FormControl(item.ExpDtTm ? moment.utc(item.ExpDtTm).local().format("MM/DD/YYYY hh:mm:ss a") : null),
            IsPickedUp: new FormControl(item.IsPickedUp),
            PickUpPos: new FormControl(item.PickUpPos),
            POSTransId: new FormControl(item.POSTransId),
            POSUserId: new FormControl(item.POSUserId),
            ActDtTm: new FormControl(item.ActDtTm),
            PkFirstName: new FormControl(item.PkFirstName),
            PkLastName: new FormControl(item.PkLastName),
            RelationCatId: new FormControl(item.RelationCatId),
            PkIdNum: new FormControl(item.PkIdNum),
            PkIdProofId: new FormControl(item.PkIdProofId),
            PkIdIssuer: new FormControl(item.PkIdIssuer),
            Remarks: new FormControl(item.Remarks),
            HandOverById: new FormControl(item.HandOverById),
            Acttime: new FormControl(item.Acttime),
            prescNum: new FormControl(item.prescNum),
            reFillNum: new FormControl(item.reFillNum),
            PartialfillNum: new FormControl(item.PartialfillNum),
            DropPickQ: new FormControl(item.DropPickQ),
            ExpDate: new FormControl(item.ExpDate),
            PickUpFromId: new FormControl(item.PickUpFromId),
            IOUQty: new FormControl(item.IOUQty),
            DrugName: new FormControl(item.DrugName),
            NDC: new FormControl(item.NDC),
            Qty: new FormControl(item.Qty),
            IsPickupHistory: new FormControl(item.IsPickupHistory),
            DpvId: new FormControl(item.DpvId),
            IsPartialPickup: new FormControl(item.IsPartialPickup),
            SignDetails: new FormControl(item.SignDetails),
            SignatureImage: new FormControl(item.SignatureImage),
            hasReceiptDetails: new FormControl(item.hasReceiptDetails),
            imageToShow: new FormControl(null),
            hasSignature : new FormControl(null),
            isPickTimeValid: new FormControl(false),
            pickTimeForDisplay: new FormControl("AM"),
            IsRphVerified: new FormControl(item.IsRphVerified),
            SignHistory: new FormControl(item.SignHistory),
            disableDateField: new FormControl(item.disableDateField)
          }));
        });
    }
    setNewVal(item) {
        if (this.checkHasPrivsToAccess(
            this.accessPrivCate.EditRx,
            this.editRxPrivs.CheckUncheckPickupRecord
        ) ) {
            if (item.value["IsPickedUp"]) {
                item.controls["PkFirstName"].patchValue(
                    this.rxDetails["Patient"]["firstname"]
                );
                item.controls["PkLastName"].patchValue(
                    this.rxDetails["Patient"]["lastname"]
                );
                item.controls["ExpDtTm"].patchValue(new Date());
                item.controls["ExpDttm1"].patchValue(new Date());
                this.getNewPickupDate(false, item);
                item.controls["ActDtTm"].patchValue(new Date());
                item.controls["PickUpFromId"].patchValue(5); // Defaulting to "Manual" as pickup from
                item.controls["DropPickQ"].patchValue(2);
            } else {
                item.controls["IsPickedUp"].setValue(false);
                this.selectedIOUPickup = item;
                this._modalService.open(this.PICKUPDELETECNFRM, { backdrop: "static", keyboard: false, centered: true,
                 windowClass: "large--content" });
            }
        } else {
            item.controls["IsPickedUp"].patchValue(!item.value["IsPickedUp"]);
            this._alertSvc.error("User does not have privileges to perform this action.", false, "long");
        }
    }
    getNewPickupDate(isFromSelection, itemFG) {
        let time;
        time =  moment(itemFG.value["ExpDtTm"]).format("hh:mm:ss");
        if (isFromSelection) {
            itemFG.controls["ExpDtTm"].patchValue(moment(itemFG.value["ExpDtTm"]).format("MM/DD/YYYY"));
            time = itemFG.value["IsPickedUp"] ?  itemFG.value["ExpDate"] : moment().format("hh:mm:ss");
        }
        const date = moment(itemFG.value["ExpDtTm"]).format("MM/DD/YYYY");
        itemFG.controls["pickTimeForDisplay"].patchValue(moment(itemFG.value["ExpDtTm"]).format("a"));
        const a = itemFG.controls["ExpDtTm"].patchValue(moment(date).format("MM/DD/YYYY"));
        itemFG.controls["ExpDate"].patchValue(time);
        let previousTime = itemFG.value["ExpDate"] + " " + itemFG.value["pickTimeForDisplay"] ;
        if(this.pickupLists?.length){
            const editingIndex = this.pickupLists.findIndex((item: any) => item.Id === itemFG.value["Id"]);
            this.pickupLists[editingIndex].ExpDate = previousTime;
        }
    }

    withNewChangeInDateSetTime(pickupItem) {
        const date = moment(pickupItem.value["ExpDtTm"]).format("MM/DD/YYYY");
        const dateTime = moment(date + "", "MM/DD/YYYY");
        const dateTimeForDisplay = moment(date + "" +  moment().format("HH:mm:ss"), "MM/DD/YYYY HH:mm:ss a");
        pickupItem.controls["pickTimeForDisplay"].patchValue(moment(dateTimeForDisplay).format("a"));
        pickupItem.controls["ExpDtTm"].patchValue(moment(dateTime).format("MM/DD/YYYY"));
        let previousTime = pickupItem.value["ExpDate"] + " " + pickupItem.value["pickTimeForDisplay"] ;
        if(this.pickupLists?.length){
            const editingIndex = this.pickupLists.findIndex((item: any) => item.Id === pickupItem.value["Id"]);
            this.pickupLists[editingIndex].ExpDate = previousTime;
        }
    }
    savenewAuditChange(pickupFG) {
        const pickupfg = pickupFG.getRawValue()
        const OriginalListIndex = this.originalPickupLists?.findIndex((item:any)=> item.Id === pickupfg?.Id)
        const pickupRxAuditModel = new RxAuditLog().pickupRxAuditModel;
        this._nwAudtUtl.saveAuditChange(
            this.originalPickupLists[OriginalListIndex],
            pickupFG.getRawValue(),
            "PickUpInfo",
            "Rx",
            this.rxDetails.PrescReFill.Id,
            pickupRxAuditModel
        );
    }
    openNotes(selctRec) {
        this.openNotesPopup = true;
        this.selectedPickupInfo = selctRec
    }

    previewPOSRecp(pickupDetails) {
        const dataToSend = {
            PrescrefillId: pickupDetails?.RxRefillId,
            POSTransId: pickupDetails?.POSTransId,
            IsPickupHistory: pickupDetails?.IsPickupHistory
        }
        this._primeEscSer.getPOSReceiptInfo(dataToSend).pipe(takeUntil(this.unsubscribe$))
            .subscribe(resp => {
                if (resp && resp.size > 0 && resp.type === "application/pdf") {
                this.dataToPrint = resp;
                const urlCreator = window.URL;
                this.pdfContent = this._sanitizer.bypassSecurityTrustResourceUrl(
                    urlCreator.createObjectURL(resp)+"#toolbar=0"
                );
                this._modalService.open(this.posReceipt, {
                    size: "lg",
                    centered: true,
                    keyboard: false,
                    backdrop: false,
                });
                } else {
                    this._alertSvc.error("Print Unsuccessfull.");
                }
            });
    }

    print() {
        const newBlob = new Blob([this.dataToPrint], { type: "application/pdf" });
        const reader = new FileReader();
        reader.readAsDataURL(newBlob);
        reader.onloadend = function () {
            const base64data = reader.result;
            this._printServ.printPdf(base64data);
        }.bind(this);
    }
    showPickUpSignDetails(pickupDetails) {
        const dataToSend = {
            PrescrefillId: pickupDetails?.RxRefillId,
            POSTransId: pickupDetails?.POSTransId,
            IsPickupHistory: pickupDetails?.IsPickupHistory
        }
        if(this.rxFG && this.rxFG.controls["Prescription"] && this.rxFG.controls["PrescReFill"]) {
            this.rxNumber = this.rxFG.controls["Prescription"].value.PrescNum + "-" + this.rxFG.controls["PrescReFill"].value.ReFillNum + (this._commonSvc.checkIsPartialFill(this.rxFG.controls["PrescReFill"].value, this.rxFG.controls["Prescription"].value) ? "-" + this.rxFG.controls["PrescReFill"].value.PartialFillNo : "") + "(" + this.rxFG.controls["insuranceInfo"].value.insuCarrier.InsurerCode + ")";
            this._primeEscSer.printPOSPickUpDetails(dataToSend).pipe(takeUntil(this.unsubscribe$)).subscribe((transId: any) => {
                 this._primeEscSer.getPatAckSign(transId?.Id, false).pipe(takeUntil(this.unsubscribe$))
            .subscribe(resp => {
                this.rxPatientModel = this.rxFG.get("Patient").value;
                this.showPatientSign = true;
                this.signId = transId.Id;
                this.refillId = this.rxFG.controls["PrescReFill"].value.Id;
                this.RPH = transId.RPH;
                this.signatureData = resp;
                  });
            });
         }
    }
    ngOnDestroy(){
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
